import React, { FC } from 'react'

import { styled } from '@mui/material'

import AddGroupCondition from './GroupCondition/AddGroupCondition'

import { useMultipleLocalizedText } from '../context/Localization/localizationHooks'

const RootContainer = styled('div')(({ center }: { center: 1 | 0 }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: center ? 'center' : 'start',
    height: center ? '50%' : 'inherit',
    flexGrow: center ? 1 : 'unset',
    justifyContent: center ? 'center' : 'unset',
    marginTop: center ? undefined : '25px',

    '& h1': {
        color: '#263238',
        fontSize: 16,
        fontWeight: 600,
        fontFamily: 'Poppins',
    },
    '& p': {
        marginTop: 8, 
        color: '#5B6971', 
        fontSize: 14,
        fontWeight: 400, 
        fontFamily: 'Open Sans'
    },
}))

export interface SetupConditionsProps {
    center?: boolean,
}

const SetupConditions: FC<SetupConditionsProps> = ({ center }) => {
    const { SETUPCONDITIONS, CONFIGURECONDITIONSDESCRIPTION } = useMultipleLocalizedText()

    return (
        <RootContainer center={center ? 1 : 0}>
            <h1>{SETUPCONDITIONS}</h1>
            <p>{CONFIGURECONDITIONSDESCRIPTION}</p>
            { center && <AddGroupCondition /> }
        </RootContainer>
    )
}

export default SetupConditions